import { apiClient } from "./apiClient";
import type {
  DentalCaseData,
  PatientListItem,
  DentalCaseJaws,
  RestorationPlan,
} from "../types/dental";

export async function getPatientList(): Promise<PatientListItem[]> {
  const response = await apiClient.getPatientList();

  if (!response.success) {
    throw new Error(response.message || "Failed to load patient list.");
  }

  return response.data;
}

export async function getDentalCase(caseId: string): Promise<DentalCaseData> {
  const response = await apiClient.getDentalCase(caseId);

  if (!response.success) {
    throw new Error(response.message || "Failed to load dental case.");
  }

  return response.data;
}

export async function saveDentalCaseData(
  caseId: string,
  jaws: DentalCaseJaws,
  restorationPlans: RestorationPlan[]
): Promise<void> {
  const response = await apiClient.saveDentalCaseData(
    caseId,
    jaws,
    restorationPlans
  );

  if (!response.success) {
    throw new Error(response.message || "Failed to save dental case.");
  }
}